import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import APP_CONFIG from '../config/app';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 20px;
  text-align: center;
  background-color: #f5f5f5;
`;

const Title = styled.h1`
  font-size: 24px;
  color: #e74c3c;
  margin-bottom: 20px;
`;

const Message = styled.p`
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
  max-width: 400px;
  line-height: 1.6;
`;

const TelegramButton = styled.a`
  display: inline-block;
  background: #2AABEE;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #229ED9;
  }
`;

const TelegramOnly = ({ children }) => {
  const [isTelegram, setIsTelegram] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const isTelegramWebApp = () => {
    try {
      return (
        window.Telegram && 
        window.Telegram.WebApp && 
        window.Telegram.WebApp.initData && 
        window.Telegram.WebApp.initDataUnsafe &&
        window.Telegram.WebApp.platform !== 'unknown'
      );
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    // Expand the WebApp to fullscreen immediately
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.expand();
    }

    const checkAndInitialize = () => {
      const isTg = isTelegramWebApp();

      if (!isTg) {
        // Case 1: App is running outside of Telegram.
        if (APP_CONFIG.BLOCK_OUTSIDE_TELEGRAM) {
          setIsTelegram(false); // Block access.
        } else {
          setIsTelegram(true); // Allow access.
        }
        setIsLoading(false);
        return;
      }

      // Case 2: App is running inside Telegram.
      const platform = window.Telegram.WebApp.platform;
      const desktopPlatforms = ['tdesktop', 'web', 'weba'];

      if (APP_CONFIG.BLOCK_ON_DESKTOP && desktopPlatforms.includes(platform)) {
        setIsTelegram(false); // Block access on desktop.
        setIsLoading(false);
        return;
      }

      // If all checks pass, initialize the app.
      try {
        window.Telegram.WebApp.expand();
        window.Telegram.WebApp.enableClosingConfirmation();
        
        window.Telegram.WebApp.ready();
        setIsTelegram(true);
      } catch (error) {
        console.error('Error initializing Telegram WebApp:', error);
        setIsTelegram(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAndInitialize();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isTelegram) {
    return (
      <Container>
        <Title>Access Denied</Title>
        <Message>
          This application is exclusively available within the Telegram app. Please open it through the official bot.
        </Message>
        <TelegramButton href={`https://t.me/${APP_CONFIG.BOT_USERNAME}`} target="_blank" rel="noopener noreferrer">
          Open in Telegram
        </TelegramButton>
      </Container>
    );
  }

  return <>{children}</>;
};

export default TelegramOnly;
